import {
  type WorkflowDecisionInDto,
  isRejectedDecision,
} from './types';
import { isTextDescriptionPart } from 'shared/types/eventDescription';

export type DecisionValidationError =
  | 'DESCRIPTION_REQUIRED_FOR_REJECTION'
  | 'DESCRIPTION_TOO_LONG'
  | 'INVALID_STAGE_ID';

const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;
const MAX_DESCRIPTION_LENGTH = 3000;

export function validateDecisionInput(
  data: WorkflowDecisionInDto
): DecisionValidationError[] {
  const errors: DecisionValidationError[] = [];

  if (isRejectedDecision(data) && (!data.description || data.description.length === 0)) {
    errors.push('DESCRIPTION_REQUIRED_FOR_REJECTION');
  }

  if (data.description) {
    const totalLength = data.description.reduce((acc, part) => {
      return acc + (isTextDescriptionPart(part) ? part.text.length : 1);
    }, 0);
    if (totalLength > MAX_DESCRIPTION_LENGTH) {
      errors.push('DESCRIPTION_TOO_LONG');
    }
  }

  if (!OBJECT_ID_REGEX.test(data.decisionOnStageId)) {
    errors.push('INVALID_STAGE_ID');
  }

  return errors;
}

export function isDecisionInputValid(data: WorkflowDecisionInDto): boolean {
  return validateDecisionInput(data).length === 0;
}
